import { TOOLTIPS } from './names';

export const toggleTooltips = () => ({
  type: TOOLTIPS,
});
